/* PAGE STYLES: HOME
   ========================================================================== */

import styled from 'styled-components';

const Styled = {
  Container: styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    // align-items: center;
  `,
};

export default Styled;
